import React from "react";
import { Link } from "react-router-dom"; // ✅ Import Link
import "../assets/css/footer_style.css";

export default function Footer() {
  return (
    <div>
      <footer className="footer">
        <div className="footer-container">
          {/* Company Info */}
          <div className="footer-section">
            <h3>Milan Brass</h3>
            <p>
              Address :
              <br /> Plot no.401,GIDC - phase-2, Dared,
              Jamnagar-361004
            </p>
            <p>Email: info@milanbrass.com</p>
          </div>

          {/* Quick Links */}
          <div className="footer-section">
            <h3>Quick Links</h3>
            <ul>
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>
                <Link to="/about">About Us</Link>
              </li>
              <li>
                <Link to="/gallery">Gallery</Link>
              </li>
              <li>
                <Link to="contact">Contact Us</Link>
              </li>
            </ul>
          </div>

          {/* Social Media */}
          <div className="footer-section">
            <h3>Social Media</h3>
            <ul className="social-links">
              <li>
                <Link
                  to="https://www.instagram.com/milanbrass_401?igsh=anVrOTVzOWZidG1x"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src="https://cdn-icons-png.flaticon.com/512/2111/2111463.png"
                    alt="Instagram"
                  />
                  Instagram
                </Link>
              </li>
              <li>
                <Link to="#">
                  <img
                    src="https://cdn-icons-png.flaticon.com/512/733/733547.png"
                    alt="Facebook"
                  />
                  Facebook
                </Link>
              </li>
              <li>
                <Link
                  to="https://www.linkedin.com/in/milan-brass-319834347?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src="https://cdn-icons-png.flaticon.com/512/174/174857.png"
                    alt="LinkedIn"
                  />
                  LinkedIn
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Copyright */}
        <div className="footer-bottom">
          <p>Copyright ©2025 Milan Brass, All rights reserved</p>
        </div>
      </footer>
    </div>
  );
}
